import { render, staticRenderFns } from "./gameWallet.vue?vue&type=template&id=45dc7498&scoped=true&"
import script from "./gameWallet.vue?vue&type=script&lang=js&"
export * from "./gameWallet.vue?vue&type=script&lang=js&"
import style0 from "./gameWallet.vue?vue&type=style&index=0&id=45dc7498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc7498",
  null
  
)

export default component.exports